function updateInThisSectionBtn() {
  const inThisSectionBtn = document.querySelector('#inThisSectionBtn');
  if (inThisSectionBtn) {
    if (window.innerWidth > 1150) {
      inThisSectionBtn.setAttribute('tabindex', '-1');
    } else {
      inThisSectionBtn.removeAttribute('tabindex');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  updateInThisSectionBtn();
  window.addEventListener('resize', updateInThisSectionBtn);
});

